import DefaultElementNodeType from '../DefaultElementNodeType';
import {TECHNOLOGY_ARTIFACT} from '../../metamodel/Concept';

export default class ArtifactNodeType extends DefaultElementNodeType {
	static get typeName() {
		return TECHNOLOGY_ARTIFACT;
	}
}
